import { render, staticRenderFns } from "./acusmaster.vue?vue&type=template&id=67bf8c10&scoped=true&"
import script from "./acusmaster.vue?vue&type=script&lang=js&"
export * from "./acusmaster.vue?vue&type=script&lang=js&"
import style0 from "./acusmaster.vue?vue&type=style&index=0&id=67bf8c10&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bf8c10",
  null
  
)

export default component.exports